import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AdminProjects from "../tribe/AdminProjects";
import MyProjects from "../tribe/MyProjects";
import "../portfolio/styles.css";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ProjectsPage() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [mine, setMine] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/auth/me`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((u) => {
        setMe(u);
        if (!u.is_admin)
          fetch(`${API}/api/projects/mine`, { credentials: "include" })
            .then((r) => (r.ok ? r.json() : []))
            .then(setMine)
            .catch(() => setMine([]));
      })
      .catch(() => setMe(false));
  }, []);

  if (me === null || (me && !me.is_admin && mine === null))
    return <div className="min-h-screen flex items-center justify-center" style={{ background: "#EDE7D9" }}>
      <p className="rp-display rp-italic text-lg text-[#5C5042]">One moment…</p></div>;

  if (me === false || (me && !me.is_admin && mine.length === 0))
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4" style={{ background: "#EDE7D9" }} data-testid="projects-empty">
        <p className="rp-display text-2xl text-[#262016]">Nothing here yet.</p>
        <button onClick={() => navigate("/tribe")} className="text-sm underline text-[#5C5042]">Go to the Tribe</button>
      </div>
    );

  if (me.is_admin) return <AdminProjects />;

  return (
    <div className="min-h-screen" style={{ background: "#EDE7D9" }} data-testid="client-projects-page">
      <main className="max-w-4xl mx-auto px-6 py-10 md:py-14">
        <button onClick={() => navigate("/tribe")} className="inline-flex items-center gap-2 mb-8 text-sm font-medium text-[#5C5042] hover:text-[#262016]">
          <ArrowLeft size={15} /> Back to the Tribe
        </button>
        <MyProjects projects={mine} />
      </main>
    </div>
  );
}
